module.exports = "/images/pin-painting-active.png?06acf312e878a5acc4192291eae4dc52";